var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GraphTitle-FAQ"},[_c('h2',{staticClass:"fit20-font-light"},[_vm._v(_vm._s(_vm.$t('totalProgress')))]),_c('SelectList',{attrs:{"eventName":'change-session'},on:{"change-session":function($event){return _vm.$emit('change-session', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }